const AlertType = {
	Success: "success",
	Info: "info",
	Warning: "warning",
	Error: "error",
};

export default Object.freeze(AlertType);
